import { useEffect, useState } from "react";

export default function Countdown({ target, label = "CHIUSURA ISCRIZIONI" }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!target) return null;
  const diff = new Date(target).getTime() - now;
  const closed = diff <= 0;
  const d = Math.max(0, Math.floor(diff / 86400000));
  const h = Math.max(0, Math.floor(diff / 3600000) % 24);
  const m = Math.max(0, Math.floor(diff / 60000) % 60);
  const s = Math.max(0, Math.floor(diff / 1000) % 60);
  const pad = (n) => String(n).padStart(2, "0");

  const cells = [
    { v: pad(d), l: "GIORNI" },
    { v: pad(h), l: "ORE" },
    { v: pad(m), l: "MIN" },
    { v: pad(s), l: "SEC" },
  ];

  return (
    <div data-testid="countdown-timer" className="flex flex-col items-start gap-2">
      <span className="font-body-sport text-[10px] sm:text-xs font-bold tracking-[0.3em] text-[#FFB703] uppercase">
        {label}
      </span>
      {closed ? (
        <span className="font-racing text-lg sm:text-xl text-[#FF1E27] tracking-widest" data-testid="countdown-closed">
          ISCRIZIONI CHIUSE
        </span>
      ) : (
        <div className="flex gap-2 sm:gap-3">
          {cells.map((c) => (
            <div
              key={c.l}
              className="flex flex-col items-center rounded-lg border border-[#3F3F4C] bg-[#121214]/80 backdrop-blur px-2.5 py-1.5 sm:px-4 sm:py-2 min-w-[54px] sm:min-w-[68px]"
            >
              <span className="font-time font-bold text-xl sm:text-3xl text-white tabular-nums leading-none">
                {c.v}
              </span>
              <span className="font-body-sport text-[8px] sm:text-[10px] tracking-[0.2em] text-gray-400 mt-1">
                {c.l}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
